import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $textcolor?: string;
  $bgcolor?: string;
}

export const SubGnbItem = styled.div<IProps>`
  .area-click {
    height: 58px;
    gap: 0 10px;
    padding: 8px 10px;
    text-align: left;
    border-radius: 2px;
    -webkit-user-select: none;
    user-select: none;
    background: #eee;
    color: #777;
  }

  .title + .sub-title {
    margin-top: 1px;
  }

  .img {
    border-radius: 2px;

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.5);
    }
  }

  ${props => css`
    &.active {
      .area-click {
        color: ${props.$textcolor} !important;
        background: ${props.$bgcolor} !important;
      }

      .img:after {
        display: none;
      }
    }
  `}

  @media ${({ theme }) => theme.media.smMax} {
    .area-click {
      height: ${mixin.pxToVw('58')};
      gap: ${mixin.pxToVw('0 10')};
      padding: ${mixin.pxToVw('8 10')};
    }

    .title + .sub-title {
      margin-top: ${mixin.pxToVw('1')};
    }
  }
`;
